// Mantine
import { Modal, Select, Button } from '@mantine/core'
import { notifications } from '@mantine/notifications'

// React
import { useState, useEffect } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Icon
import { Check } from 'tabler-icons-react'

export default function ProductionOrderEditStatus({
    opened,
    onClose,
    onChanged,
    ...productionOrder
}) {
    const statusOptions = [
        { value: 'scheduled', label: 'Programmé' },
        { value: 'open', label: 'En cours' },
        { value: 'closed', label: 'Terminé' },
        { value: 'cancelled', label: 'Annulé' },
    ]

    const [statusValue, setStatusValue] = useState(productionOrder.status)

    // API
    const { requestPatch } = useAxiosApi()

    const saveStatus = async () => {
        await requestPatch(`/production-orders/${productionOrder.id}`, {
            status: statusValue,
        })

        onChanged()
        onClose()

        notifications.show({
            title: 'Statut modifié',
            message: "Le statut de l'assemblage a été modifié.",
            color: 'green',
            icon: <Check size={15} />,
        })
    }

    return (
        <>
            <Modal opened={opened} onClose={onClose} title="Modifier le statut">
                <div className="flex flex-col gap-3">
                    <Select
                        label="Statut"
                        value={statusValue}
                        allowDeselect={false}
                        onChange={setStatusValue}
                        data={statusOptions}
                    />

                    <Button onClick={saveStatus}>Enregistrer le statut</Button>
                </div>
            </Modal>
        </>
    )
}
